import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import PropTypes from 'prop-types';
import Series from '../Series'; // This HOC returns Series component with injected type

export default function withSeriesType(seriesType) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var additionalPropTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var SeriesComponent = function SeriesComponent(props) {
    return /*#__PURE__*/React.createElement(Series, _extends({}, props, additionalProps, {
      type: seriesType.toLowerCase()
    }));
  };

  SeriesComponent.displayName = "".concat(seriesType, "Series");
  return SeriesComponent;
}